/** sessionStorage: já exibiu o modal automático de avisos na lista de produtos nesta sessão (após login). */
export const PRODUCTS_STATUS_NOTIFICATION_MODAL_SESSION_KEY =
  'uaiBrindes:productsStatusNotificationModalShown';

export function clearProductsStatusNotificationModalSessionFlag() {
  try {
    sessionStorage.removeItem(PRODUCTS_STATUS_NOTIFICATION_MODAL_SESSION_KEY);
  } catch {
    /* ignore private mode / quota */
  }
}
